import { BaseModel } from 'app/core/models/base.model';
import { ServiceTask } from '../serviceTask/serviceTask';

export class ServiceRecord extends BaseModel {
	startDateTime: string;
	finishDateTime: string;
	description: string;
	serviceTask: ServiceTask;
}
